'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	return function (date) {
		if (!date) {
			return new Date(2020, 10, 10);
		}
		var split = date.split('/');
		var year = +split[2];
		var month = +split[1] - 1;
		var day = +split[0];
		return new Date(year, month, day);
	};
};

;


// WEBPACK FOOTER //
// ./client/components/filters/reparseDate.js